export default __webpack_public_path__ + "static/media/website-design.afc0da52.jpg";